var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display"},[_c('label',[_vm._v("email")]),_c('p',[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }